import { mergeAttributes, Node } from '@tiptap/core';

const Signature = Node.create({
	name: 'signature',

	group: 'inline',

	inline: true,

	atom: true,

	addOptions() {
		return {
			t: key => key,
		};
	},
	addAttributes() {
		return {
			image: {
				default: null,
				parseHTML: element => element.getAttribute('data-image'),
				renderHTML: attributes => {
					if (!attributes.image) {
						return {};
					}

					return {
						'data-image': attributes.image,
					};
				},
			},
			username: {
				default: null,
				parseHTML: element => element.getAttribute('data-username'),
				renderHTML: attributes => {
					if (!attributes.username) {
						return {};
					}

					return {
						'data-username': attributes.username,
					};
				},
			},
			date: {
				default: null,
				parseHTML: element => element.getAttribute('data-date'),
				renderHTML: attributes => {
					if (!attributes.date) {
						return {};
					}

					return {
						'data-date': attributes.date,
					};
				},
			},
			time: {
				default: null,
				parseHTML: element => element.getAttribute('data-time'),
				renderHTML: attributes => {
					if (!attributes.time) {
						return {};
					}

					return {
						'data-time': attributes.time,
					};
				},
			},
			preview: {
				default: null,
				parseHTML: element => element.getAttribute('data-preview'),
				renderHTML: attributes => {
					if (!attributes.preview) {
						return {};
					}

					return {
						'data-preview': attributes.preview,
					};
				},
			},
			signedLabel: {
				default: null,
				parseHTML: element => element.getAttribute('data-signed-label'),
				renderHTML: attributes => {
					if (!attributes.signedLabel) {
						return {};
					}

					return {
						'data-signed-label': attributes.signedLabel,
					};
				},
			},
			medicalCredentials: {
				default: null,
				parseHTML: element => element.getAttribute('data-medical-credentials'),
				renderHTML: attributes => {
					if (!attributes.medicalCredentials) {
						return {};
					}
					return {
						'data-medical-credentials': attributes.medicalCredentials,
					};
				},
			},
			dateLabel: {
				default: null,
				parseHTML: element => element.getAttribute('data-date-label'),
				renderHTML: attributes => {
					if (!attributes.dateLabel) {
						return {};
					}

					return {
						'data-date-label': attributes.dateLabel,
					};
				},
			},
			timeLabel: {
				default: null,
				parseHTML: element => element.getAttribute('data-time-label'),
				renderHTML: attributes => {
					if (!attributes.timeLabel) {
						return {};
					}

					return {
						'data-time-label': attributes.timeLabel,
					};
				},
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: `div[data-type="${this.name}"]`,
			},
			{
				tag: `span[data-type="${this.name}"]`,
			},
		];
	},

	renderHTML({ node, HTMLAttributes }) {
		const { t } = this.options;
		if (!node?.attrs?.image) {
			return [
				'span',
				mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
					'data-type': this.name,
				}),
				[
					'span',
					{
						style: `${
							this.options.isEditorStyles ? '' : 'font-family:Arial, sans-serif;color:#000;'
						}position: relative; border:none; min-height:${
							this.options.isEditorStyles ? '0px' : '15px'
						};padding:0px;
							max-height:${this.options.isEditorStyles ? 'unset' : node.attrs.preview ? '20px' : 'unset'};`,
						class: 'container',
					},
					[
						'span',
						{ class: 'credentialsContainer' },
						[
							'span',
							{
								class: `credentialItem ${
									this.options.isEditorStyles && node.attrs.preview ? 'editorStyles' : ''
								}`,
							},
							`${node.attrs.signedLabel} ${node.attrs.medicalCredentials ?? node.attrs.username} ${t(
								'ON'
							)} ${node.attrs.date} ${t('AT')} ${node.attrs.time}`,
						],
						node.attrs.preview
							? [
									'span',
									{
										class: this.options.isEditorStyles
											? 'signatureOverlayEditorStyles'
											: 'signatureOverlay',
									},
									['span', `${t('signature')}`],
							  ]
							: ['span'],
					],
				],
			];
		}
		return [
			'span',
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				'data-type': this.name,
			}),
			[
				'span',
				{
					style: `${
						this.options.isEditorStyles ? '' : 'font-family:Arial, sans-serif;color:#000;'
					}position: relative; 
						border:none; min-height:${this.options.isEditorStyles ? '0px' : '15px'};padding:0px; 
						max-height:${this.options.isEditorStyles ? 'unset' : node.attrs.preview ? '20px' : 'unset'}`,
					class: 'container',
				},
				[
					'span',
					{ class: 'credentialsContainer', style: 'align-items:center' },
					[
						'span',
						{
							style: `display:${
								this.options.isEditorStyles ? (node.attrs.preview ? 'none' : 'flex') : 'block'
							}; ${
								this.options.isEditorStyles
									? 'width:100%; background:#fff; padding-bottom:20px; justify-content:center;'
									: 'margin-bottom:14px;'
							}`,
							class: 'imgContainer',
						},
						['img', { src: node.attrs.image, width: '90px' }],
					],
					[
						'span',
						{
							class: `credentialItem ${
								this.options.isEditorStyles && node.attrs.preview ? 'editorStyles' : ''
							}`,
						},
						`${node.attrs.signedLabel} ${node.attrs.medicalCredentials ?? node.attrs.username} ${t('ON')} ${
							node.attrs.date
						} ${t('AT')} ${node.attrs.time}`,
					],
					node.attrs.preview
						? [
								'span',
								{
									class: this.options.isEditorStyles
										? 'signatureOverlayEditorStyles'
										: 'signatureOverlay',
								},
								['span', `${t('signature')}`],
						  ]
						: ['span'],
				],
			],
		];
	},
});

export default Signature;
